<template>
  <div>
    <HomeHero />
    <BentoGrid />
    <TheApproach />
    <WhoSheWorksWith />
    <StrategicNavigation />
    <CredibilityStrip />
    <HomepageCTA />
  </div>
</template>

<script setup>
import HomeHero from '@/components/sections/HomeHero.vue';
import BentoGrid from '@/components/sections/BentoGrid.vue';
import TheApproach from '@/components/sections/TheApproach.vue';
import WhoSheWorksWith from '@/components/sections/WhoSheWorksWith.vue';
import StrategicNavigation from '@/components/sections/StrategicNavigation.vue';
import CredibilityStrip from '@/components/sections/CredibilityStrip.vue';
import HomepageCTA from '@/components/sections/HomepageCTA.vue';
</script>

<style scoped>
</style>
